export default function CxbLogo() {
  return <img src="/assets/images/logo.png" width="64" />;
}
